import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=48660206&scoped=true"
import script from "./CompanyHeader.vue?vue&type=script&lang=js"
export * from "./CompanyHeader.vue?vue&type=script&lang=js"
import style0 from "./CompanyHeader.vue?vue&type=style&index=0&id=48660206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48660206",
  null
  
)

export default component.exports